import { ColumnDef } from "@tanstack/react-table";
import { BiDotsHorizontalRounded } from "react-icons/bi";

// Helper functions
const enumToStringConverter = (value: string) => {
	if (!value) return "";
	return value
		.split("_")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join(" ");
};

const moneyFormat = (amount: number) => {
	if (!amount && amount !== 0) return "0.00";
	return amount.toLocaleString("en-US", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
};

const formatDate = (params: any) => {
	if (!params.value) return "";
	const date = new Date(params.value);
	return date.toLocaleDateString();
};

// ==================== EMPLOYEE BAND COLUMNS ====================
export const employeeBandColumns: ColumnDef<any>[] = [
	{
		accessorKey: "name",
		header: "Name",
		size: 200,
		minSize: 150,
		maxSize: 350,
	},
	{
		accessorKey: "description",
		header: "Description",
		size: 380,
		minSize: 250,
		maxSize: 600,
	},
	{
		accessorKey: "level",
		header: "Level",
		size: 180,
		minSize: 120,
		maxSize: 300,
	},
	{
		accessorKey: "minimumBasicPay",
		header: "Minimum Basic Pay",
		size: 250,
		minSize: 200,
		maxSize: 350,
		cell: ({ row }) => {
			const amount = row.original.minimumBasicPay;
			const currency = row.original.companyCurrency?.currency;
			return amount ? `${currency?.code || ""} ${moneyFormat(amount)}` : "--";
		},
	},
	{
		accessorKey: "maximumBasicPay",
		header: "Maximum Basic Pay",
		size: 250,
		minSize: 200,
		maxSize: 350,
		cell: ({ row }) => {
			const amount = row.original.maximumBasicPay;
			const currency = row.original.companyCurrency?.currency;
			return amount ? `${currency?.code || ""} ${moneyFormat(amount)}` : "--";
		},
	},
	{
		accessorKey: "payPeriod",
		header: "Pay Period",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ getValue }) => enumToStringConverter(getValue() as string),
	},
	{
		accessorKey: "createdAt",
		header: "Date Created",
		size: 200,
		minSize: 150,
		maxSize: 250,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		accessorKey: "modifiedAt",
		header: "Date Modified",
		size: 200,
		minSize: 150,
		maxSize: 250,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		id: "actions",
		header: "Actions",
		size: 100,
		minSize: 80,
		maxSize: 150,
		cell: ({ row, table }) => {
			const meta = table.options.meta as any;
			return (
				<button
					onClick={(e) => {
						e.stopPropagation();
						if (meta?.onActionClick) {
							meta.onActionClick(row.original, e);
						}
					}}
					className="p-2 hover:bg-gray-100 rounded-full transition-colors"
				>
					<BiDotsHorizontalRounded className="text-xl" />
				</button>
			);
		},
	},
];

// Default column visibility
export const employeeBandColumnVisibility = {
	name: true,
	description: true,
	level: true,
	minimumBasicPay: true,
	maximumBasicPay: true,
	payPeriod: true,
	createdAt: true,
	modifiedAt: true,
	actions: true,
};
